
import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {MatDialog} from "@angular/material";
import {CalendarTypeDialogComponent} from "./calendar-type-dialog/calendar-type-dialog.component";


@Component({
  selector: 'calendar-type',
  templateUrl: './calendar-type.component.html',
  styleUrls: ['calendar-type.component.css']
})

export class CalendarTypeComponent implements OnInit{


  //Parameters neeeded to display calendar type questions
  @Input() question_index : number;
  @Input() question_name : string;
  @Input() question_name_second : string;
  @Input() is_mandt : boolean;
  @Output() user_Resp = new EventEmitter<string[]>();
  @Input() userRes : string[];
  @Input() indexOfRepeater : number;
  @Input() question_number : number;
  // @Input() is_range:boolean;

  //Generating month array for all the possible months
  months : MonthsClass = [{inWords:"Jan", inNumber :"1"},{inWords :"Feb", inNumber : "2"},{inWords :"Mar", inNumber :"3"},{inWords :"Apr", inNumber:"4"},{inWords:"May", inNumber:"5"},
    {inWords:"Jun", inNumber:"6"},{inWords:"July", inNumber:"7"},{inWords:"Aug", inNumber:"8"},{inWords:"Sep", inNumber:"9"},{inWords:"Oct", inNumber:"10"},{inWords:"Nov", inNumber:"11"},
    {inWords:"Dec", inNumber:"12"}];

  //array to store years
  years : string[] = [];

  selectedMonth : string = "Month";
  selectedYear : string;
  selectedMonthIndex : number;

  // selectedMaxMonth : string = "Month";
  // selectedMaxYear : string;
  // selectedMaxMonthIndex : number;

  notClicked : boolean = true;
  response:string;
  
  constructor (public  dialog : MatDialog) {
  }

  ngOnInit(){
    this.notClicked = true;
    this.response = this.userRes[this.indexOfRepeater];
    let currentYear : number = (new Date()).getFullYear();
    this.selectedYear = currentYear.toString();
    // this.selectedMaxYear = currentYear.toString();
    this.selectedMonth = this.months[(new Date()).getMonth()].inWords;
    // this.selectedMaxMonth = this.months[(new Date()).getMonth()].inWords;
    this.selectedMonthIndex = (new Date()).getMonth() + 1;
    // this.selectedMaxMonthIndex = (new Date()).getMonth() + 1;
    while(currentYear >= 1900){
      this.years.push(currentYear.toString());
      currentYear = currentYear - 1;
    }
  }

  //Open Dialog box to get month and year
  //ToDo: Change it with better dialog implementation
  openDialogBox(){
    this.notClicked = false;
    this.response = this.selectedMonthIndex + '-' + this.selectedYear;
    this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
  }

//user clicked on a month
  clickedMonth(index : number){
    this.selectedMonth = this.months[index].inWords;
    this.selectedMonthIndex = index + 1;
    this.response = this.selectedMonthIndex + '-' + this.selectedYear;
    this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
  }

  //user clicked on a year
  clickedYear(index : number){
    this.selectedYear = this.years[index].toLocaleString();
    this.response = this.selectedMonthIndex + '-' + this.selectedYear;
    this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
  }

  // //user clicked on a month
  // clickedMaxMonth(index : number){
  //   this.selectedMaxMonth = this.months[index].inWords;
  //   this.selectedMaxMonthIndex = index + 1;
  //   this.response = this.selectedMaxMonthIndex + '-' + this.selectedMaxYear;
  //   this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
  // }

  // //user clicked on a year
  // clickedMaxYear(index : number){
  //   this.selectedMaxYear = this.years[index].toLocaleString();
  //   this.response = this.selectedMaxMonthIndex + '-' + this.selectedMaxYear;
  //   this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
  // }

}

export type MonthsClass = Array<{inWords: string, inNumber: string}>;


// WEBPACK FOOTER //
// ./src/app/questions-type/calendar-type/calendar-type.component.ts